// extracted by mini-css-extract-plugin
export var body = "Table-module--body--e2d9a";
export var cell = "Table-module--cell--64867";
export var container = "Table-module--container--fb9b7";
export var fill = "Table-module--fill--7ad9b";
export var head = "Table-module--head--a8431";
export var lg = "Table-module--lg--b3306";
export var lgBreak = "1200";
export var lightGrey = "Table-module--lightGrey--168ed";
export var md = "Table-module--md--a68f9";
export var mdBreak = "992";
export var neutralNavy = "Table-module--neutralNavy--f8c8c";
export var row = "Table-module--row--ceed2";
export var smBreak = "768";
export var strong = "Table-module--strong--72739";
export var table = "Table-module--table--33d86";
export var xsBreak = "480";